import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CatalogDetFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    public Get(catId: any, language: number = 0, organizationId: any = null): Observable<any> {
        if (organizationId == null) {
            return  this._httpClient.get<any>(this._urlBase + 'api/CatalogDet/Web?catId=' + catId
        + '&language=' + language);
        } else {
            return  this._httpClient.get<any>(this._urlBase + 'api/CatalogDet/Web?catId=' + catId
        + '&language=' + language + '&organizationId=' + organizationId);
        }
    }
}
